module.exports = __webpack_public_path__ + "img/iconlogo-branco 2.61e87bc0.svg";